import { Product } from './product';
import { Discounts } from './discountCode';
import { $Q, $Qll } from '../utils/querySelector';

export const variantOnChange = (component) => {
  const parents = $Qll(component);

  if (parents.length > 1) {
    return parents.forEach((parent) => {
      iterationOptions(parent);
    });
  }

  return iterationOptions(parents[0]);
};

function iterationOptions(parent) {
  const firstParent = $Q('.variants', $Q('.product__description--variantform'));

  if (firstParent != null) {
    optionsChecked(firstParent);
  }

  return options(parent).forEach((option) => {
    option.addEventListener('change', () => {
      selectVariant(parent);
    });
  });
}

function selectVariant(parent) {
  let variantName = optionsChecked(parent);
  let variants = JSON.parse($Q('#variants', parent).value);
  const variantFilter = variants.filter(
    (variant) => variant.title.toLowerCase() === variantName.toLowerCase()
  );
  const stickyForm = $Q('#sticky-form [name="id"]');
  if (stickyForm) {
    $Q('#sticky-form [name="id"]').value = variantFilter[0].id;
  }
  $Q('#page-product-form [name="id"]').value = variantFilter[0].id;

  renderVariantInfo(parent);
}

function optionsChecked(parent) {
  let myOptions = [];

  options(parent).forEach((option) => {
    if (option.type === 'radio') {
      if (option.checked === true) {
        myOptions = [...myOptions, option.value];
        renderVariantSelected(option.value, option.name);
      }
    } else {
      myOptions = [...myOptions, option.value];
    }
  });
  return buildOption(myOptions);
}

/**
 * Show in screen selected color
 * @param {String} optionValue
 * @param {String} optionName
 * @author Michael Ballen <michael.ballen@gradiweb.com>
 */
function renderVariantSelected(optionValue, optionName) {
  const titleNode = $Q(`#${optionName}`);

  if (titleNode != null) {
    titleNode.innerText = `: ${optionValue}`;
  }
}

/**
 *
 * @param {Node} parent
 * @author Michael Ballen <michael.ballen@gradiweb.com>
 * Render the information for each variant when this is selected
 */
function renderVariantInfo(parent) {
  const product = new Product();
  const discount = new Discounts();
  const selectedVariantId = $Q('[name="id"]', parent).value;
  const productHandle = $Q('[name="handle"]', parent).value;

  //Render variant information and customer discount
  product.getVariantInfo(selectedVariantId, productHandle).then(() => {
    window.backInStockRegisterEvents();
  });
  discount.printPriceProductPage();
}

const options = (parent) => $Qll('.js-option', parent);
const buildOption = (options) => options.join(' / ');
